import { FIELD_TYPES } from './fieldTypes';
import {
  isEmpty,
  validateLength,
  forbiddenCharacters,
} from '../utility/validation';

export const SYSTEM_ROLES = {
  ADMIN: 'ADMIN',
  ASSOCIATE: 'ASSOCIATE',
  MODERATOR: 'MODERATOR',
  USER: 'USER',
};

export const SYSTEM_ROLES_BY_ID = {
  ADMIN_ID: 1,
  MODERATOR_ID: 10,
  USER_ID: 11,
  ASSOCIATE_ID: 12,
};

export const SYSTEM_ROLE_OPTIONS = [
  {
    id: 1,
    name: SYSTEM_ROLES.ADMIN,
    value: SYSTEM_ROLES.ADMIN,
    label: 'Admin',
    is_system: true,
  },
  {
    id: 10,
    name: SYSTEM_ROLES.MODERATOR,
    value: SYSTEM_ROLES.MODERATOR,
    label: 'Moderator',
    is_system: true,
  },
  {
    id: 11,
    name: SYSTEM_ROLES.USER,
    value: SYSTEM_ROLES.USER,
    label: 'Employee',
    is_system: true,
  },
  {
    id: 12,
    name: SYSTEM_ROLES.ASSOCIATE,
    value: SYSTEM_ROLES.ASSOCIATE,
    label: 'External Associate',
    is_system: true,
  },
];

export const ROLE_FIELD = [
  {
    name: 'name',
    required: true,
    shouldRemoveFieldSpacing: true,
    shouldRemoveFieldError: true,
    validators: [
      { type: 'required', validator: isEmpty },
      {
        type: 'maxRoleLength',
        validator: value => validateLength(value, 0, 150),
      },
      {
        type: 'forbiddenCharacters',
        validator: forbiddenCharacters,
      },
    ],
  },
];

export const PRIMARY_ROLE_FIELD = [
  {
    name: 'primaryRoleId',
    type: FIELD_TYPES.SELECT,
    optionsKey: 'roles',
    isSearchDisabled: true,
    parser: {
      value: 'id',
      label: 'label',
    },
  },
  {
    name: 'changeRoleWarrning',
    type: FIELD_TYPES.SUBTITLE,
    isToggleable: true,
    variant: 'subtitle2',
    shouldRender: values =>
      values.primaryRoleId < SYSTEM_ROLES_BY_ID.MODERATOR_ID &&
      !!values?.additionalRoleId,
  },
];

export const ADDITIONAL_ROLE_FIELD = [
  {
    name: 'additionalRoleId',
    type: FIELD_TYPES.SELECT,
    optionsKey: 'roles',
    shouldRemoveFieldSpacing: true,
    isSearchDisabled: true,
    parser: {
      value: 'id',
      label: 'label',
    },
  },
];
